const MENU_ITEM_PREFIX = "MenuItem";

export const MENU_ITEM_IMAGE_SPACING = 5;

export const MENU_ITEM_CLASSES = {
  buttonRoot: `${MENU_ITEM_PREFIX}-buttonRoot`,
  imageBox: `${MENU_ITEM_PREFIX}-imageBox`,
  label: `${MENU_ITEM_PREFIX}-label`,
  arrow: `${MENU_ITEM_PREFIX}-arrow`,
};
